import { defaultPermissions } from "../../../constants";

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

/** @typedef {"vip" | "subscribed" | "trial" | "expired"} AccessTier */

/**
 * Resolve page access tier in priority order: VIP → subscribed → trial → expired.
 */
function resolveTier(userIsVerified, activeSubscription, trialExpired) {
	if (userIsVerified) return "vip";
	if (activeSubscription) return "subscribed";
	if (!trialExpired) return "trial";
	return "expired";
}

function resolveTreePermissions(planType, trialUser, treePermissions) {
	const grantedTrees = treePermissions || {};

	if (planType === "plo" || trialUser) {
		return { ...defaultPermissions.nlheBasic, ...defaultPermissions.plo, ...grantedTrees };
	}
	if (planType === "basic") {
		return { ...defaultPermissions.nlheBasic, ...grantedTrees };
	}
	return { ...grantedTrees };
}

/**
 * @param {object} params
 * @param {object} params.userInfo - Firebase user record
 * @param {string|null} params.subscriptionStatus - Stripe subscription status
 * @param {string|null} params.planType - "basic" | "plo" | null
 * @param {object} [params.treePermissions] - Admin- or user-granted tree access
 */
export default function resolveUserAccess({ userInfo, subscriptionStatus, planType, treePermissions }) {
	const userIsVerified = !!userInfo?.verified;
	const activeSubscription = subscriptionStatus === "active";
	const trialExpired = !!(userInfo?.trialEnd && userInfo.trialEnd < Date.now());
	const tier = resolveTier(userIsVerified, activeSubscription, trialExpired);
	const trialUser = tier === "trial";
	const access = tier !== "expired";
	const permissions = resolveTreePermissions(planType, trialUser, treePermissions);
	const trialEnd = userInfo?.trialEnd || Date.now() + SEVEN_DAYS_MS;

	return {
		tier,
		access,
		userIsVerified,
		trialUser,
		trialExpired,
		trialEnd,
		modalOpen: trialUser,
		permissions,
	};
}
